import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const DownloadIconNoBg: React.FC<AddIconProps> = ({ size = 22, color = '#292D32', className, onClick }) => (
  <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.82617 21.3845H18.6723M12.7492 3.61523V17.4357M12.7492 17.4357L17.6851 12.4998M12.7492 17.4357L7.81335 12.4998" stroke={color} strokeWidth="1.52308" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default DownloadIconNoBg;
